<input
  matInput
  [required]="required"
  [(ngModel)]="autocompleteInput"
  (keyup)="onAddressChange(autocompleteInput)"
  type="text"
  #addresstext
/>
